/**
 * Created by stonewang on 2017/8/24.
 */
import Reflux from 'reflux';

export const dictionaryActions = Reflux.createActions([
	'paramChange', 'useStoreChange','dependentChange','dataIdChange'
]);

export class dictionaryStore extends Reflux.Store {
	constructor() {
		super();
		this.state = {
			searchObj: {
				s: 10,
				p: 1,
				sKey:'',
				name:'',
				active:''
			},
			dependentId:null,
			dataId:null,
			useStore: false
		}
		this.listenables = dictionaryActions;
	}
	
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			searchObj:{
				...this.state.searchObj,
				...data
			}
		});
	}
	
	onDependentChange(id,callback){
		this.setState({dependentId:id});
		if(callback){
			callback(id);
		}
	}
	
	
	onDataIdChange(id){
		this.setState({dataId:id});
	}
	
}


// WEBPACK FOOTER //
// ./src/routes/dictionary/store.js